<div class="container-in" [class.error]="false" [class.pointer-events-none]="this.disabled" [class.disabled-input]="disabled">
  <div class="sub" (click)="sub()" [class.disabled-button]="disabled">-</div>
  <input type="number" (keyup)="blur()" [(ngModel)]="value" [disabled]="this.disabled" [class.disabled-button]="disabled">
  <div class="plus" (click)="add()" [class.disabled-button]="disabled">+</div>
</div>
